import Plyr from '../../../assets/custom_components/plyr/plyr'

/* @ngInject */
function AuditFormController ($scope, $state, $element, $rootScope, $q, $stateParams, $translate, $sce, $timeout, AuditService, ModalService, ToastService, SegmentService, BusinessDataService, UdsModalService, NewAssetService, SocialMediaService, Utils, CONSTANTS) {
  const getAuditNewDateDialogController = () => $q.when(import('../../dialogs/audit-new-date/audit-new-date-dialog.controller'))
  const getFinishWithNonconformitiesDialogController = () => $q.when(import('../../dialogs/finish-with-nonconformities/finish-with-nonconformities-dialog.controller'))
  const getBusinessDataListDialogController = () => $q.when(import('../../../arts/dialogs/business-data/list/business-data-list-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

  $scope.isInReactNativeWebView = Utils.isInReactNativeWebView()
  $scope.flags = {
    loading: true,
    formReadOnly: true,
    isSocialMediaAudit: false
  }
  $scope.audit = {}
  $scope.versions = []
  $scope.fields = []
  $scope.form = {}
  $scope.ratings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  $scope.companyFeatures = {
    actionPlan: false
  }
  $scope.uploadedFiles = []
  $scope.auditSocialMedia = null

  const api = {
    getAuditNewDateDialogController,
    getFinishWithNonconformitiesDialogController,
    getBusinessDataListDialogController,
    getUpgradeCompanyPlanDialogController,
    _handleSuccessGetAudit,
    _handleSuccessGetAuditBriefing,
    _handleSuccessSubmitAudit,
    _handleSuccessRateAudit,
    _parseFieldsToPayloadStructure,
    _parseFieldsToDropdownStructure,
    _normalizeFieldsValues,
    _countSignatureFields,
    _getAuditVersions,
    _getAuditBriefing,
    _handleSuccessGetAuditBriefingVersions,
    _setBussinessDataField,
    _selectBusinessData,
    _validateCompanyFeatures,
    _openUpgradeCompanyPlanDialog,
    _showFieldError,
    _handleErrorSubmitAudit,
    _createAuditSocialMedia,
    _getAssetUrl,
    _getSocialMediaType
  }
  this.getApi = () => api

  activate()

  function activate () {
    ModalService.close()
    api._validateCompanyFeatures()
    AuditService.getAuditById($stateParams.id)
      .then(api._handleSuccessGetAudit)
      .then(api._getAuditVersions)
      .catch(ToastService.defaultErrorToast)
  }

  const deregisterUpdateSelectedContext = $rootScope.$on('update-selected-context', () => {
    api._setBussinessDataField($scope.fields)
  })

  const deregisterRefreshBusinessData = $rootScope.$on('refresh-business-data', () => {
    api._setBussinessDataField($scope.fields)
  })

  $scope.$on('$destroy', () => {
    deregisterUpdateSelectedContext()
    deregisterRefreshBusinessData()
  })

  function _validateCompanyFeatures () {
    $rootScope.getCompanyFeaturesAndAddons().then((companyFeaturesAndAddons) => {
      const features = companyFeaturesAndAddons.features
      $scope.companyFeatures.actionPlan = !!features['CHECKLIST.ACTION_PLAN']
    })
  }

  $scope.handleActionPlan = function () {
    if (!$scope.companyFeatures.actionPlan) {
      const pricingData = {
        name: $translate.instant('billingFeatures.actionPlan'),
        slug: 'CHECKLIST.ACTION_PLAN'
      }
      api._openUpgradeCompanyPlanDialog(pricingData)
    }
  }

  function _openUpgradeCompanyPlanDialog (pricingData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: {
          featureName: pricingData.name,
          featureSlug: pricingData.slug
        }
      })
      upgradeCompanyPlanDialog.open()
    })
  }

  $scope.handleSubmitForm = function (fields) {
    const fieldsWithoutValue = fields.filter(field => field.mandatory && !field.value)
    const fieldsWithoutAsset = fields.filter(field => {
      const withoutAsset = field.acceptAnswerAssets && field.mandatoryAssets && !field.fieldValueAssets.length
      return (field.mandatory && withoutAsset) || (!field.mandatory && field.value && withoutAsset)
    })

    if (fieldsWithoutValue.length > 0) {
      return api._showFieldError(fieldsWithoutValue, 'fieldRequiredValue')
    }

    if (fieldsWithoutAsset.length > 0) {
      return api._showFieldError(fieldsWithoutAsset, 'localizedAssetsRequiredMessage')
    }

    $scope.flags.loading = true
    // parse signature fields
    const signatureFields = fields.filter((field) => field.type === 'SIGNATURE' && field.value)
    const promises = signatureFields.map((field) => {
      return AuditService.uploadSignatureFieldToS3(field)
        .then((uploadedFile) => {
          field.value = uploadedFile.id
        })
    })

    const type = api._getSocialMediaType($scope.audit)

    return Promise.all(promises)
      .then(() => {
        AuditService.fillAuditBriefing($stateParams.id, { fields: api._parseFieldsToPayloadStructure(fields) }).then(() => {
          SegmentService.track('responded-checklist', { checklist_id: $scope.audit.id, briefing_id: $scope.audit.briefingId, type })
          if ($scope.audit.briefing.campaignId) {
            SegmentService.track('responded-checklist', { campaign_id: $scope.audit.briefing.campaignId, type })
          }
        }).then(api._handleSuccessSubmitAudit).catch(ToastService.defaultErrorToast).finally(() => { $scope.flags.loading = false })
      })
  }

  $scope.handleUpdateAudit = function (fields) {
    const fieldsWithoutImage = fields.filter(field => {
      const withoutAsset = field.acceptAnswerAssets && field.mandatoryAssets && !field.fieldValueAssets.length
      return (field.mandatory && withoutAsset) || (!field.mandatory && field.value && withoutAsset)
    })

    const type = api._getSocialMediaType($scope.audit)

    if (fieldsWithoutImage.length > 0) {
      var fieldsId = fieldsWithoutImage.map(oField => oField.order.toString()).toString().replace(',', ', ')
      const sErrorMessage = $translate.instant('localizedAssetsRequiredMessage', { fieldsId: fieldsId })
      ToastService.showErrorToast(sErrorMessage)
    } else {
      $scope.flags.loading = true
      AuditService.updateAuditBriefing($stateParams.id, { fields: api._parseFieldsToPayloadStructure(fields) }).then(() => {
        SegmentService.track('responded-action-plan-checklist', { checklist_id: $scope.audit.id, briefing_id: $scope.audit.briefingId, type })
      }).then(api._handleSuccessSubmitAudit).catch(api._handleErrorSubmitAudit).finally(() => { $scope.flags.loading = false })
    }
  }

  $scope.hasNonconformities = function () {
    return $scope.fields.some(item => item.hasNonconformity)
  }

  $scope.handleRateAudit = function (audit, askDate) {
    $scope.flags.loading = true
    $scope.form.finishAnyway = false
    $scope.form.date = moment()

    $scope.form.fields = $scope.fields.reduce((acc, item) => {
      if (item.hasNonconformity) {
        acc.push({
          fieldValueId: item.fieldValueId,
          comment: item.nonconformity ? item.nonconformity.comment : ''
        })
      }
      return acc
    }, [])

    if ($scope.form.fields.length) {
      if (askDate) {
        api.getAuditNewDateDialogController().then(({ AuditNewDateDialogController }) => {
          ModalService.showModal({
            templateId: 'auditNewDate.html',
            templateUrl: '/audit/dialogs/audit-new-date/audit-new-date-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: AuditNewDateDialogController
          }).then(newDate => {
            if (newDate) {
              $timeout(() => {
                $scope.flags.loading = true

                const type = api._getSocialMediaType($scope.audit)

                AuditService.rateAuditBriefing(audit.id, Object.assign({}, $scope.form, { date: newDate })).then(() => {
                  SegmentService.track('sent-action-plan-checklist', { checklist_id: $scope.audit.id, briefing_id: $scope.audit.briefingId, type })
                }).then(api._handleSuccessRateAudit).catch(ToastService.defaultErrorToast).finally(() => { $scope.flags.loading = false })
              })
            } else {
              $scope.flags.loading = false
            }
          })
        })
        return
      }

      api.getFinishWithNonconformitiesDialogController().then(({ FinishWithNonconformitiesDialogController }) => {
        ModalService.showModal({
          templateId: 'finishWithNonconformities.html',
          templateUrl: '/audit/dialogs/finish-with-nonconformities/finish-with-nonconformities-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: FinishWithNonconformitiesDialogController
        }).then(shouldFinish => {
          if (shouldFinish) {
            $timeout(() => {
              $scope.flags.loading = true

              const type = api._getSocialMediaType($scope.audit)

              AuditService.rateAuditBriefing(audit.id, Object.assign({}, $scope.form, { finishAnyway: true })).then(() => {
                SegmentService.track('finished-checklist', { checklist_id: $scope.audit.id, briefing_id: $scope.audit.briefingId, type })
              }).then(api._handleSuccessRateAudit).catch(ToastService.defaultErrorToast).finally(() => { $scope.flags.loading = false })
            })
          }
          $scope.flags.loading = false
        })
      })
    } else {
      $timeout(() => {
        $scope.flags.loading = true

        AuditService.rateAuditBriefing(audit.id, $scope.form).then(api._handleSuccessRateAudit).catch(ToastService.defaultErrorToast).finally(() => { $scope.flags.loading = false })
      })
    }
  }

  $scope.isSubmitButtonDisabled = function (fields) {
    return $scope.flags.formReadOnly || fields.some(field => (!field.value || field.loadingAttachment) && field.mandatory)
  }

  $scope.handleClickOnRate = function (rate, audit) {
    if (audit.status !== 'ANALYZE' || !$rootScope.isUserSysAdminAdminDesigner()) {
      return
    }
    $scope.form.score = rate
  }

  $scope.changeVersion = function (item) {
    if ($scope.selectedVersion === item) {
      return
    }
    const param = {
      version: item.version
    }
    AuditService
      .getAuditById($stateParams.id, param)
      .then(audit => {
        $scope.selectedVersion = item
        return audit
      })
      .then(api._handleSuccessGetAudit)
      .catch(ToastService.defaultErrorToast)
  }

  $scope.goBack = () => {
    $state.go('audit.list', { audit: $scope.audit.id })
  }

  $scope.initializePlyrVideo = (content) => {
    const controls = [
      'play',
      'mute',
      'progress',
      'current-time',
      'duration'
    ]

    const playerElement = $element.find('.audit-form-page-social-media-asset__video')[0]
    const player = new Plyr(playerElement, { controls })

    player.source = {
      type: 'video',
      sources: [
        {
          src: content.assetUrl,
          type: 'video/mp4'
        }
      ]
    }
  }

  $scope.getSocialMediaDescription = (description) => {
    return $translate.instant(`socialMedia.nonConformityModal.problemList.${description}`)
  }

  $scope.getAccountName = (account) => {
    return `@${account.username}`
  }

  function _handleSuccessSubmitAudit () {
    ToastService.defaultSuccessToast()
    if ($stateParams.redirect === 'arts') {
      $state.go('user.arts')
    } else {
      $state.go('audit.list', { audit: $scope.audit.id })
    }
  }

  function _handleSuccessRateAudit () {
    const type = api._getSocialMediaType($scope.audit)
    SegmentService.track('evaluated-checklist', { checklist_id: $scope.audit.id, briefing_id: $scope.audit.briefingId, type })
    $state.go('audit.list', { audit: $scope.audit.id })
  }

  function _handleSuccessGetAudit (audit) {
    const param = {}

    if ($scope.selectedVersion) {
      param.version = $scope.selectedVersion.version
    }
    api._getAuditBriefing(audit, param)

    $scope.audit = audit
    $scope.form.score = audit.score
    api._createAuditSocialMedia(audit)
    $scope.flags.isSocialMediaAudit = $scope?.audit?.briefing?.name === CONSTANTS.DEFAULT_SOCIAL_MEDIA_BRIEFING_NAME

    if (audit.status === 'SCHEDULED' || audit.status === 'NONCONFORM') {
      $scope.flags.formReadOnly = false

      if ($scope.versions.length) {
        const lastVersion = $scope.versions.slice(-1)

        if (!lastVersion.includes($scope.selectedVersion)) {
          $scope.flags.formReadOnly = true
        }
      }
    }

    return audit
  }

  function _handleSuccessGetAuditBriefing (briefing) {
    $scope.flags.loading = false
    $scope.fields = briefing.sections[0].fields
    $scope.audit.automaticScore = briefing.automaticScore

    const areThereBussinessDataFields = briefing.sections[0].fields.some(field => field.businessDataFieldId)

    if (areThereBussinessDataFields && $scope.audit.status === 'SCHEDULED') {
      api._selectBusinessData()
    }

    api._countSignatureFields(briefing.sections[0].fields)
    api._normalizeFieldsValues(briefing.sections[0].fields)
    api._parseFieldsToDropdownStructure(briefing.sections[0].fields)

    if ($scope.selectedVersion && $scope.selectedVersion.version > 1 && $scope.audit.status === 'ANALYZE') {
      AuditService.getBriefingFieldsNonconformities($scope.audit.id, $scope.selectedVersion.version - 1).then(fields => {
        const noncFieldId = fields.map(a => a.nonconformity.parentFieldId)
        $scope.fields.forEach(field => {
          if (!noncFieldId.includes(field.id)) {
            field.hasNonconformity = false
          }
        })
      })
    }

    if ($scope.audit.automaticScore) {
      $scope.audit.calculatedScore = $scope.audit.score
      $scope.form.score = $scope.audit.score
    }
  }

  function _handleSuccessGetAuditBriefingVersions (versions) {
    $scope.versions = versions
    $scope.selectedVersion = versions[versions.length - 1]
    $timeout(() => {
      $('.version-dropdown').dropdown()
    }, 50, false)
  }

  function _getAuditBriefing (audit, version) {
    AuditService
      .getAuditBriefing(audit.id, version)
      .then(api._handleSuccessGetAuditBriefing)
      .catch(ToastService.defaultErrorToast)
  }

  function _getAuditVersions (audit) {
    AuditService
      .getAuditBriefingVersions(audit.id)
      .then(api._handleSuccessGetAuditBriefingVersions)
      .catch(ToastService.defaultErrorToast)
  }

  function _parseFieldsToPayloadStructure (fields) {
    return fields.map(field => {
      const payloadField = {
        id: field.id,
        briefingId: field.briefingId,
        type: field.type,
        fieldValueAssets: field.fieldValueAssets,
        comment: field.comment
      }

      if (field.type === 'DROPDOWN' || field.type === 'RADIO') {
        payloadField.value = { id: field.value }
      } else {
        payloadField.value = field.value
      }
      if (field.type === 'CHECKBOX') {
        payloadField.fields = field.fields
      }

      return payloadField
    })
  }

  function _normalizeFieldsValues (fields) {
    fields.forEach(field => {
      let values = (field.field_values && field.field_values.length && field.field_values) || ((field.type === 'DROPDOWN' || field.type === 'RADIO') && field.fields.filter(option => option.field_values && option.field_values.length))

      if (field.type === 'CHECKBOX' && !field.value) {
        field.value = []
      }

      if (!values.length) {
        return
      }

      field.fieldValueAssets = values[0].fieldValueAssets
      field.nonconformity = values[0].nonconformity || {}
      field.comment = values[0].comment

      if (field.type === 'CHECKBOX') {
        const fieldValues = field.field_values[0]
        field.fieldValueId = field.field_values[0].id
        let checkedOptions = []

        if (fieldValues) {
          checkedOptions = field.fields.filter(innerField => fieldValues.metadata.find(data => data.title === innerField.title))
        }

        values = checkedOptions
        field.comment = fieldValues.comment
      }

      let value
      if (field.type === 'DROPDOWN' || field.type === 'RADIO') {
        if (values[0]) {
          value = values[0].fieldId
          field.fieldValueAssets = values[0].fieldValueAssets
          field.nonconformity = values[0].nonconformity
          field.comment = values[0].comment
          field.fieldValueId = values[0].id
          if (field.score && $scope.audit.automaticScore) {
            field.hasNonconformity = values[0].score === 0
          }
        }
        field.calculatedScore = ((field.score / 100) * values[0].score || 0) || 0
      } else if (field.type === 'NUMBER') {
        value = Number(values[0].value)
        field.fieldValueId = values[0].id
      } else if (field.type === 'DATE') {
        value = moment(values[0].value)
        field.fieldValueId = values[0].id
      } else if (field.type === 'CHECKBOX') {
        value = values.map(data => data.title)
        if (field.score && $scope.audit.automaticScore) {
          field.hasNonconformity = field.fields.length > values.length
        }
      } else {
        value = values[0].value
        field.nonconformity = values[0].nonconformity
        field.fieldValueId = values[0].id
      }

      if (field.nonconformity) {
        const nonConfComment = field.nonconformity.comment || ''
        field.nonconformity.htmlComment = $sce.trustAsHtml(nonConfComment)
      }
      field.value = value
    })
  }

  function _countSignatureFields (fields) {
    let count = 0
    fields.forEach(field => {
      if (field.type === 'SIGNATURE') {
        field.count = ++count
      }
    })
  }

  function _parseFieldsToDropdownStructure (fields) {
    fields.forEach(field => {
      if (field.type === 'DROPDOWN' || field.type === 'RADIO' || field.type === 'CHECKBOX') {
        field.fields = field.fields.map(option => {
          if (field.type === 'CHECKBOX') {
            return { id: option.id, value: option.title, label: option.title, score: option.score, title: option.title, description: option.description }
          }
          return { value: option.id, label: option.title, score: option.score }
        })
      }
    })
  }

  function _selectBusinessData () {
    BusinessDataService.getBusinessDataService().then(data => {
      api.getBusinessDataListDialogController().then(({ BusinessDataListDialogController }) => {
        if (data.length === 0) {
          ModalService.showModal({
            templateId: 'businessDataListDialog.html',
            templateUrl: '/arts/dialogs/business-data/list/business-data-list-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: BusinessDataListDialogController,
            data: {
              emptyMode: {
                type: data ? 'primary' : 'secondary'
              }
            }
          })
        } else {
          ModalService.showModal({
            templateId: 'businessDataListDialog.html',
            templateUrl: '/arts/dialogs/business-data/list/business-data-list-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: BusinessDataListDialogController,
            data: {
              page: 'audit'
            }
          })
        }
      })
    })
  }

  function _setBussinessDataField (fields) {
    BusinessDataService.getBusinessDataByContextId($rootScope.selectedContext).then(data => {
      fields.forEach(field => {
        field.businessDataField = data.find(bussiness => bussiness.id === field.businessDataFieldId)
        if (field.type === 'DROPDOWN') {
          const businessOptionValue = field.businessDataField.contexts[0] ? field.businessDataField.options.find(option => option.id === parseInt(field.businessDataField.contexts[0].contextValue.value)) : null
          if (businessOptionValue) {
            field.value = field.fields.find(field => field.label === businessOptionValue.title).value
            $timeout(() => {
              $('.input-dropdown').dropdown('set selected', field.value)
            }, 200, false)
          }
        } else {
          field.value = field.businessDataField.contexts[0] ? field.businessDataField.contexts[0].contextValue.value : null
        }
      })
    })
  }

  function _showFieldError (fields, messageError) {
    const fieldsId = fields.map(oField => oField.order.toString()).toString().replace(',', ', ')
    const sErrorMessage = $translate.instant(messageError, { fieldsId: fieldsId })
    ToastService.showErrorToast(sErrorMessage)
  }

  function _handleErrorSubmitAudit (error) {
    if (error.data.code === 'EXPIRED') {
      ToastService.showErrorToast($translate.instant('expiredAuditError'))
    } else {
      ToastService.defaultErrorToast()
    }
  }

  function _createAuditSocialMedia (audit) {
    if (audit.socialMediaAudit) {
      $scope.auditSocialMedia = {
        ...audit.socialMediaAudit
      }

      if ($scope.auditSocialMedia?.content) {
        const postId = $scope.auditSocialMedia.content.id
        $scope.auditSocialMedia.content.assetUrl = api._getAssetUrl('instagram', postId)
      }

      return
    }

    $scope.auditSocialMedia = null
  }

  function _getAssetUrl (socialType = 'instagram', postId) {
    return SocialMediaService.getContentAsset(socialType, postId)
  }

  function _getSocialMediaType (audit) {
    if (audit?.socialMediaAudit?.content) {
      return 'social_media'
    }

    return 'store'
  }
}

export { AuditFormController }
